"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function classNameForZSpace(zSpace) {
    if (zSpace < 0 || zSpace > 24) {
        throw new TypeError("z-space should be a number between 0-24");
    }
    return constants_1.BASE_CLASS_NAME + "--z" + zSpace;
}
exports.classNameForZSpace = classNameForZSpace;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/elevation/lib/utils.js
// module id = ./node_modules/@react-mdc/elevation/lib/utils.js
// module chunks = 1